import { vModelText as _vModelText, mergeProps as _mergeProps, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock } from "vue";
const _hoisted_1 = ["id", "disabled", "placeholder", "rows"];
const _hoisted_2 = ["id", "disabled", "placeholder", "rows"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_field_block = _resolveComponent("g-field-block");
    return (_openBlock(), _createBlock(_component_g_field_block, _mergeProps(_ctx.$attrs, {
        name: _ctx.dataMember,
        "is-auto-fill": _ctx.isAutoFill,
        "error-message": _ctx.errorMessage,
        label: _ctx.label
    }), {
        "g-field-input": _withCtx(({ identification, error, disabled, size, setFocusClass, removeFocusClass, hasSuffix, hasPrefix }) => [
            (!_ctx.updateLazy)
                ? _withDirectives((_openBlock(), _createElementBlock("textarea", _mergeProps({
                    key: 0,
                    class: ['form-control h-100', _ctx.isInvalid ? 'is-invalid' : ''],
                    id: identification,
                    disabled: disabled,
                    placeholder: _ctx.placeholder,
                    rows: _ctx.rows
                }, _ctx.inputAttrInternal, {
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.internalValue) = $event)),
                    onBlur: _cache[1] || (_cache[1] =
                        //@ts-ignore
                        (...args) => (_ctx.onFocusOut && _ctx.onFocusOut(...args))),
                    onKeyup: _cache[2] || (_cache[2] =
                        //@ts-ignore
                        (...args) => (_ctx.onEnterKey && _ctx.onEnterKey(...args)))
                }), null, 16, _hoisted_1)), [
                    [_vModelText, _ctx.internalValue]
                ])
                : _withDirectives((_openBlock(), _createElementBlock("textarea", _mergeProps({
                    key: 1,
                    class: ['form-control h-100', _ctx.isInvalid ? 'is-invalid' : ''],
                    id: identification,
                    disabled: disabled,
                    placeholder: _ctx.placeholder,
                    rows: _ctx.rows
                }, _ctx.inputAttrInternal, {
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((_ctx.internalValue) = $event)),
                    onBlur: _cache[4] || (_cache[4] =
                        //@ts-ignore
                        (...args) => (_ctx.onFocusOut && _ctx.onFocusOut(...args))),
                    onKeyup: _cache[5] || (_cache[5] =
                        //@ts-ignore
                        (...args) => (_ctx.onEnterKey && _ctx.onEnterKey(...args)))
                }), null, 16, _hoisted_2)), [
                    [
                        _vModelText,
                        _ctx.internalValue,
                        void 0,
                        { lazy: true }
                    ]
                ])
        ]),
        _: 1
    }, 16, ["name", "is-auto-fill", "error-message", "label"]));
}
